var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"background":"","total":_vm.paginationData.total,"current-page":_vm.paginationData.current,"page-size":_vm.paginationData.pageSize,"hide-on-single-page":_vm.paginationData.hideOnSinglePage,"layout":"prev, pager, next"},on:{"current-change":_vm.paginationData.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }